import { createReducer, on } from '@ngrx/store';
import { LangActions } from './lang.actions';
import { initialLangState } from './lang.state';

export const langsReducer = createReducer(
  initialLangState,
  on(LangActions.loadLangs, (state, { payload }) => {
    return {
      ...state,
    };
  }),

  on(LangActions.loadLangsSuccess, (state, { langs, reg_locale }) => {
    return {
      ...state,
      ...langs,
      reg_locale,
    };
  }),

  on(LangActions.loadLangsFailure, (state, { payload }) => {
    console.error(payload);
    return {
      ...state,
    };
  }),
);
